import { redirect } from '@tanstack/react-router';
import { ensureAuthData } from '@/api/auth/auth-query';
import { queryClient } from '@/api/common/client';
import { GlobalRole } from '@/lib/auth/models';
import { ADMIN_DASHBOARD } from '@/lib/constants/routes';

/**
 * `beforeLoad` delle pagine admin riservate ai SUPERADMIN (le API rispondono
 * 403 a SYSTEM): chi non lo è torna alla dashboard. Sta sul layout, così vale
 * anche per le rotte figlie aperte da un link. La sidebar e la palette le
 * nascondono con `superadminOnly`.
 */
export async function requireSuperadmin(): Promise<void> {
  const data = await ensureAuthData(queryClient);
  if (data.user?.globalRole !== GlobalRole.SUPERADMIN) {
    throw redirect({ to: ADMIN_DASHBOARD });
  }
}
